<template>
	<div>
		<vxe-modal v-model="modal_model" title="万里牛账户" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			streamdata: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				modal: true,
				loading: false,
				modal_width:1000,
				modal_height:500,
				list_formConfig: [{
					field: 'acc_name',
					title: '账户名称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'inst_account',
					title: '银行账号',
					itemRender: {
						name: '$input'
					}
				}] 
			}
		},
		methods:{
			list_beforeCreateGrid(gridOptions){
				//gridOptions.showFooter = true		
				gridOptions.toolbarConfig.buttons = []						
				// gridOptions.toolbarConfig.buttons = [{
				// 	name: '导出',
				// 	status: 'success',
				// 	code: 'export'
				// }]
				gridOptions.columns = [{
						field: 'acc_code',
						title: '编码',
					}, {
						field: 'acc_name',
						title: '账户名称',
					},{
						field: 'inst_name',
						title: '银行类型',
					}, {
						field: 'inst_account',
						title: '银行账号',
					}, {
						field: 'baseamount',
						title: '期初金额',
						editRender:{
							name:'$inputNumber',
							props:{
								precision:2
							}
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#67C23A" type = "text" size = "mini" onClick = {() => {this.save(row)}}>保存</el-button>]
							}
						}
					}
				]
				//gridOptions.formConfig = false
			},
			list(page, form) {				
				return new Promise((resolve, reject) => {
					this.$api.bankaccount.list({
						...form,
						...{type:this.isauto == 5?null:'wln'}
					}).then((res) => {
						if(this.isauto == 6){
							res.list.forEach((item)=>{
								item.corpCode = null
								item.bankType = item.inst_name
								item.accName = item.acc_name
								item.bankAcc = item.inst_account
								item.bal = item.balance
							})
						}
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			save(row){
				this.$api.bankaccount.updatebankinfo({
					acc_uid:row.acc_uid,
					baseamount:row.baseamount,
				}).then(()=>{
					this.$message.success('操作成功')
				})
				
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		}
	}
</script>